module.exports = __webpack_public_path__ + "static/pershing-with-droid-298fcfb62c0f2b16a6aded6b4bb77aec.jpg";